import { FormBuilderFieldType } from '../types/badge.type'

export type BadgeElement = {
  id: string
  personaFieldId?: string
  field_type: keyof typeof BadgeElementFieldType
  icon?: string
  value: string
  label?: string
  targetElement?: HTMLElement
  style?: BadgeElementStyle
  columnContainerIndex?: number
  previous?: string
  weight?: number
}

export type BadgeElementStyle = {
  'border-radius'?: string
  'font-weight'?: string
  height?: string
  'justify-content'?: string
  'qr-number-display'?: string
}

enum extraBadgeElementFieldType {
  PERSONA_NAME = 'PERSONA_NAME',
  PARENT_PERSONA_NAME = 'PARENT_PERSONA_NAME',
  QR_CODE = 'QR_CODE',
  DTCM_QR_CODE = 'DTCM_QR_CODE',
  SPACER = 'SPACER'
}

export const BadgeElementFieldType = {
  ...FormBuilderFieldType,
  ...extraBadgeElementFieldType
}

export const TestBadgeData = {
  fullname: 'John Doe',
  job_title: 'General Manager',
  organization: 'Micetribe',
  email: 'john.doe@micetribe.com',
  country: 'Wakanda',
  input: 'Lorem ipsum dolor sit amet.',
  phone: '+37287121234',
  radio: 'Option A',
  gender: 'Male',
  numeric: 99,
  category: 'category',
  line1: 'line1',
  line2: 'line2',
  line3: 'line3',
  line4: 'line4',
  datetime: '1 January 1970',
  qr_code: 'https://library.micetribe.com/images/testing-qr-sm.png',
  spacer: ''
}
